<template>
  <div
    class="
      tw-flex
      tw-flex-col
      tw-items-center
      tw-justify-center
      tw-mx-auto
      tw-max-w-condensed-content
      tw-py-24
      tw-rounded-lg
    "
  >
    <img
      class="sf-empty-state-image"
      :src="$imagesRequire('empty_states/past-client-meetings.svg')"
    />
    <h2 class="tw-text-2xl tw-mt-0 tw-mb-2">{{ copy.noPastMeetings }}</h2>
    <p>
      {{ copy.useThe }}
      <RemarkTag v-if="talkingPointTag" :tag="talkingPointTag" />
      {{ copy.tagToPlan }}
    </p>
  </div>
</template>

<script setup lang="ts">
import type { RemarkTag as RemarkTagType } from '@app/shared/types/sf-data'

import useI18n from '@app/shared/vue/composables/use-I18n'
import RemarkTag from '@app/application/communication/sections/communication/components/remarks/remark-tag.vue'

const I18n = useI18n()
const copy = {
  noPastMeetings: I18n.t('client_meetings.past.no_past_meetings_yet'),
  useThe: I18n.t('client_meetings.past.use_the'),
  tagToPlan: I18n.t('client_meetings.past.tag_to_plan'),
}

interface Props {
  talkingPointTag: RemarkTagType | undefined
}

defineProps<Props>()
</script>
